import CsvImportDialog from "controls/CsvImportDialog";
import { csvRequiredColumnsMessage, csvToAssetUploader } from "controls/CsvPreviewTable";
import Message from "controls/Message";
import { useActionFragment } from "hooks/useAction";
import { FileUpload } from "mdi-material-ui";
import React from "react";

export const REFEREE_CSV_HEADERS = ["First Name", "Last Name", "Email"];

export function downloadRefereeCsvTemplate() {
  const csv = [REFEREE_CSV_HEADERS.join(","), ["John", "Smith", "john@example.com"].join(",")].join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "referee_import_template.csv";
  a.click();
  URL.revokeObjectURL(url);
}

const COLUMN_VALIDATORS = {
  "First Name": (v) => (!v.trim() ? "Cannot be empty" : null),
  "Last Name": (v) => (!v.trim() ? "Cannot be empty" : null),
  Email: (v) => {
    if (!v.trim()) return "Cannot be empty";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim())) return "Must be a valid email address";
    return null;
  },
};

const AI_PROMPT = {
  subject: "referee",
  headers: REFEREE_CSV_HEADERS,
  formatNotes: {
    "First Name": "required — the referee's first name",
    "Last Name": "required — the referee's last name",
    Email: "required — a valid email address (e.g. name@example.com)",
  },
  exampleRow: ["John", "Smith", "john@example.com"],
};

ImportRefereeCsvDialog.useButtonProps = ({ orgId }) => {
  if (!orgId) return null;
  return { icon: <FileUpload />, content: "Import Referees CSV" };
};

export default function ImportRefereeCsvDialog({ orgId, onClose }) {
  const importRefereeCsv = useActionFragment("importRefereeCsv", "import { id }");

  const handleSubmit = async (csvHeaders, csvRows, uploaderValue) => {
    const assetUploader = csvToAssetUploader(csvHeaders, csvRows, uploaderValue.name);
    await importRefereeCsv({ input: { orgId, assetUploader } }, { suppressError: true });
  };

  return (
    <CsvImportDialog
      title="Import Referees CSV"
      infoMessage={csvRequiredColumnsMessage(REFEREE_CSV_HEADERS)}
      columnValidators={COLUMN_VALIDATORS}
      requiredHeaders={REFEREE_CSV_HEADERS}
      onDownloadTemplate={downloadRefereeCsvTemplate}
      aiPrompt={AI_PROMPT}
      onSubmit={handleSubmit}
      renderSuccess={
        <Message
          type="success"
          content="Your import has been queued. We'll email you if any rows could not be imported."
        />
      }
      onClose={onClose}
    />
  );
}
